import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const twoColumnCardBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE
] as const

export type TwoColumnCardBackgroundColor =
  (typeof twoColumnCardBackgroundColors)[number]
